{
  "brandTitle": "VBB PLAY — Тікелей қолдау",
  "brandShort": "VBB PLAY Қолдау",
  "liveLabel": "VBB PLAY Тікелей қолдау",
  "online": "Онлайн",
  "offline": "Офлайн",
  "close": "Жабу",
  "moreOptions": "Қосымша",
  "closeChat": "Чатты жабу",
  "closeMenu": "Мәзірді жабу",
  "operator": "VBB PLAY операторы",
  "removeFile": "Файлды өшіру",
  "attachFile": "Файл қосу",
  "loadFailed": "Жүктелмеді.",
  "fileTooLarge": "Файл 50 МБ-тан үлкен.",
  "sendFailed": "Хабар жіберілмеді ({{status}})",
  "networkError": "Желі қатесі. Қайта көріңіз.",
  "nameRequired": "Атыңызды енгізіңіз.",
  "emailInvalid": "Дұрыс e-mail жазыңыз.",
  "topicRequired": "Тақырыпты таңдаңыз.",
  "messageRequired": "Мәселені қысқа жазыңыз.",
  "consentRequired": "Құпиялылыққа келісім қажет.",
  "requestFailed": "Сұрау жіберілмеді.",
  "messagePlaceholder": "Қысқа сипаттама…",
  "sending": "Жіберілуде…",
  "startLive": "Чатты бастау",
  "ratingFailed": "Баға жіберілмеді.",
  "ratingPlaceholder": "Қысқа пікір (міндетті емес)",
  "contactSaveFailed": "Байланыс сақталмады.",
  "save": "Сақтау",
  "loginRequired": "Тікелей қолдауға жазу үшін кіріңіз.",
  "intakeHint": "Жылдамырақ көмек үшін мәліметтеріңізді енгізіңіз.",
  "back": "Артқа",
  "yourName": "Атыңыз",
  "yourEmail": "E-mail мекенжайыңыз",
  "emailPlaceholder": "email@мысал.com",
  "topicLabel": "Тақырып",
  "topicSelect": "Таңдаңыз…",
  "messageLabel": "Мәселеңіз немесе хабар",
  "consentLong": "Жеке деректерді өңдеуге келісемін. Құпиялылық саясатымен таныстым.",
  "soundOff": "🔊 Дыбысты өшіру",
  "soundOn": "🔇 Дыбысты қосу",
  "rateOperator": "⭐ Операторды бағалау",
  "editContact": "✎ Жеке деректерді өзгерту",
  "searchingOperator": "🔎 Оператор ізделуде...",
  "waitingOperator": "⏳ Өтінім қабылданды. Операторды күтіңіз.",
  "operatorJoined": "Оператор {{name}} чатқа қосылды",
  "sendFailedShort": "Жіберілмеді",
  "retry": "Қайталау",
  "cameraShot": "📷 Камерамен түсіру",
  "pickPhoto": "🖼️ Сурет таңдау",
  "pickVideo": "🎬 Бейне таңдау",
  "pickFile": "📁 Файл немесе құжат таңдау",
  "textPlaceholder": "Мәтін...",
  "messageAria": "Хабар",
  "sendAria": "Жіберу",
  "emojiAria": "Эмодзи",
  "rateTitle": "Операторды бағалау",
  "submitRate": "Жіберу",
  "editContactTitle": "Жеке деректерді өзгерту",
  "cameraPermissionTitle": "Камера рұқсаты",
  "cameraPermissionBody": "Суретке түсіру үшін камераға рұқсат керек. Браузер терезесі құрылғы тілінде қалуы мүмкін.",
  "allowCamera": "Рұқсат беру",
  "notNow": "Қазір емес",
  "namePlaceholder": "Аты",
  "topic_deposit": "Депозит мәселесі",
  "topic_withdraw": "Шығару мәселесі",
  "topic_balance": "Баланс мәселесі",
  "topic_game": "Ойын мәселесі",
  "topic_bonus": "Бонус мәселесі",
  "topic_account": "Аккаунт / кіру",
  "topic_tech": "Техникалық мәселе",
  "topic_other": "Басқа сұрақ",
  "fileOpenFailed": "Файл ашылмады: {{name}}",
  "retryShort": "Қайта",
  "fileLoading": "Файл жүктелуде: {{name}}",
  "emoji_smileys": "Жүздер",
  "emoji_people": "Ишаралар",
  "emoji_nature": "Табиғат",
  "emoji_food": "Тағам",
  "emoji_activity": "Спорт",
  "emoji_travel": "Саяхат",
  "emoji_objects": "Заттар",
  "emoji_symbols": "Таңбалар",
  "emoji_flags": "Жалаулар"
}
